"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromptFlyoutContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _utils = require("@site/utils");
var _uxUtils = require("@site/ux-utils");
var _sharedComponents = require("@site/shared-components");
var _box = _interopRequireDefault(require("@ux/box"));
var _button = _interopRequireDefault(require("@ux/button"));
var _space = _interopRequireWildcard(require("@ux/space"));
var _text = _interopRequireDefault(require("@ux/text"));
var _utilities = require("../../utilities");
var _PromptRecommendations = require("../../styles/PromptRecommendations");
var _constants = require("../../constants");
var _EidCodes = _interopRequireDefault(require("../../EidCodes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ICON_GAP = 'md';
const GetHelpSearchingSkeleton = ({
  isDesktop
}) => {
  return /*#__PURE__*/_react.default.createElement(_box.default, {
    "data-testid": "domain-search-content-prompt-skeleton",
    inlinePadding: _space.sizeOptions.MD,
    blockPadding: _space.sizeOptions.MD
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: isDesktop ? '40%' : '1000%',
    height: "1rem"
  }), /*#__PURE__*/_react.default.createElement(_space.default.div, {
    block: _space.sizeOptions.MD
  }), /*#__PURE__*/_react.default.createElement(_box.default, {
    gap: "md",
    stretch: true,
    wrap: true,
    orientation: isDesktop ? 'horizontal' : 'vertical'
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: isDesktop ? '50%' : '100%',
    height: "1rem"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: isDesktop ? '40%' : '100%',
    height: "1rem"
  })), /*#__PURE__*/_react.default.createElement(_space.default.div, {
    block: _space.sizeOptions.MD
  }), /*#__PURE__*/_react.default.createElement(_box.default, {
    gap: "md",
    stretch: true,
    wrap: true,
    orientation: isDesktop ? 'horizontal' : 'vertical'
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: isDesktop ? '40%' : '100%',
    height: "1rem"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: isDesktop ? '50%' : '100%',
    height: "1rem"
  })), /*#__PURE__*/_react.default.createElement(_space.default.div, {
    block: _space.sizeOptions.SM
  }));
};
const PromptButton = ({
  text: displayText,
  disabled,
  promptId,
  onClick,
  eidPrefix
}) => {
  // to track % of prompts shown vs number selected we need to track the impression
  (0, _react.useEffect)(() => {
    (0, _utils.logEvent)({
      eid: eidPrefix + _EidCodes.default.promptSuggestionsShown,
      type: 'view',
      properties: {
        promptId
      }
    });
  }, [promptId, eidPrefix]);
  if (!displayText) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "prompt-button",
    "data-testid": "prompt-recommendation-button",
    disabled: disabled,
    size: "small",
    design: "secondary",
    text: Array.isArray(displayText) ? displayText[0] : displayText,
    onClick: onClick
  });
};

// eslint-disable-next-line complexity
const PromptFlyoutContent = ({
  eidPrefix,
  styling,
  prompts,
  promptResult,
  logger
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const deviceType = (0, _uxUtils.useDeviceType)();
  const {
    isDesktop
  } = deviceType;
  const {
    handlePromptSelect,
    addToCartStatus,
    getIsDomainPurchased
  } = promptResult;
  const {
    promptsData,
    promptStatus,
    options: {
      promptConfig = {}
    } = {}
  } = prompts || {};
  const {
    merchData: recommendationsData,
    ventureData: wamVenturesData
  } = promptsData || {};
  const isAddingToCart = addToCartStatus === _constants.REQUEST_STATUS.LOADING;
  const isDataLoading = promptStatus === _constants.REQUEST_STATUS.LOADING;
  const venturesToPrompt = (wamVenturesData?.ventures || []).filter(venture => {
    // check for venture which has fields required for the api which gets suggestions
    const hasVertical = Boolean(venture?.properties?.vertical);
    const hasDomain = Boolean(venture?.domainName);
    const isActive = venture?.status === 'active';
    return hasVertical && hasDomain && isActive;
  }).slice(0, _constants.VENTURE_PROMPTS_TO_SHOW); // maybe make this dynamic depending on which other prompts are being shown

  const {
    recommendations = []
  } = recommendationsData || {};
  const {
    portfolioRecommendations = [],
    countryRecommendations = [],
    compactRecommendations = []
  } = _react.default.useMemo(() => (0, _utilities.groupSearchRecommendations)({
    recommendations,
    getIsDomainPurchased
  }), [recommendations]);
  const hidePrompts = !isDataLoading && [venturesToPrompt, portfolioRecommendations, countryRecommendations, compactRecommendations].every(items => items?.length === 0);
  (0, _react.useEffect)(() => {
    (0, _utils.logImpression)(`${eidPrefix}${_EidCodes.default.promptRecommendationShown}`);
  }, []);
  if (hidePrompts) {
    return null;
  }
  if (promptStatus === _constants.REQUEST_STATUS.LOADING) {
    return /*#__PURE__*/_react.default.createElement(GetHelpSearchingSkeleton, {
      isDesktop: isDesktop
    });
  }
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.ErrorBoundary, {
    fallback: null,
    logErrorFunc: logger?.()
  }, /*#__PURE__*/_react.default.createElement(_box.default, {
    inlinePadding: _space.sizeOptions.MD,
    blockPadding: _space.sizeOptions.MD
  }, /*#__PURE__*/_react.default.createElement(_PromptRecommendations.StyledPromptFlyoutContent, {
    id: "promptFlyoutContent",
    "data-cy": "prompt-flyout-content",
    "data-testid": "prompt-flyout-content-container",
    className: "prompt-flyout-content",
    space: {
      block: _space.sizeOptions.LG,
      inline: _space.sizeOptions.LG
    },
    stretch: true,
    styling: styling
  }, /*#__PURE__*/_react.default.createElement("section", {
    "data-testid": "domain-search-content-prompt-section",
    className: "prompt-section"
  }, /*#__PURE__*/_react.default.createElement(_text.default.h4, {
    text: formatMessage({
      id: promptConfig?.title || 'searchRecommendation.prompt.title'
    }),
    as: "label",
    size: 1,
    className: "font-weight-bold margin-bottom-1"
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    text: formatMessage({
      id: promptConfig?.description || 'searchRecommendation.prompt.description'
    }),
    className: "margin-bottom-0",
    size: -1
  }), /*#__PURE__*/_react.default.createElement(_space.default.div, {
    block: _space.sizeOptions.MD
  }), /*#__PURE__*/_react.default.createElement(_box.default, {
    gap: ICON_GAP,
    orientation: "horizontal"
  }, /*#__PURE__*/_react.default.createElement(_box.default, {
    gap: "sm",
    stretch: true,
    wrap: true,
    orientation: isDesktop ? 'horizontal' : 'vertical'
  }, venturesToPrompt.map(venture => {
    const ventureName = venture.businessName || formatMessage({
      id: 'searchRecommendation.website.new'
    });
    return /*#__PURE__*/_react.default.createElement(PromptButton, {
      key: venture.ventureId,
      promptId: _constants.PROMPT_ID.VENTURE,
      disabled: isAddingToCart,
      eidPrefix: eidPrefix,
      text: formatMessage({
        id: promptConfig?.ventureText || 'searchRecommendation.prompt.venture'
      }, {
        ventureName
      }),
      onClick: () => handlePromptSelect({
        venture,
        title: formatMessage({
          id: 'searchRecommendation.venture.title'
        }, {
          ventureName
        }),
        description: formatMessage({
          id: 'searchRecommendation.venture.description'
        }, {
          ventureName
        }),
        promptId: _constants.PROMPT_ID.VENTURE
      })
    });
  }), portfolioRecommendations.length > 0 && /*#__PURE__*/_react.default.createElement(PromptButton, {
    promptId: _constants.PROMPT_ID.PORTFOLIO,
    disabled: isAddingToCart,
    eidPrefix: eidPrefix,
    text: formatMessage({
      id: promptConfig?.portfolioText || 'searchRecommendation.prompt.portfolio'
    }),
    onClick: () => handlePromptSelect({
      recommendations: portfolioRecommendations,
      title: formatMessage({
        id: 'searchRecommendation.prompt.portfolio.title'
      }),
      description: formatMessage({
        id: 'searchRecommendation.prompt.portfolio.description'
      }),
      promptId: _constants.PROMPT_ID.PORTFOLIO
    })
  }), countryRecommendations.length > 0 && /*#__PURE__*/_react.default.createElement(PromptButton, {
    promptId: _constants.PROMPT_ID.COUNTRY,
    disabled: isAddingToCart,
    eidPrefix: eidPrefix,
    text: formatMessage({
      id: promptConfig?.ccTldText || 'searchRecommendation.prompt.ccTld'
    }),
    onClick: () => handlePromptSelect({
      recommendations: countryRecommendations,
      title: formatMessage({
        id: 'searchRecommendation.prompt.ccTld.title'
      }),
      description: formatMessage({
        id: 'searchRecommendation.prompt.ccTld.description'
      }),
      promptId: _constants.PROMPT_ID.COUNTRY
    })
  }), compactRecommendations.length > 0 && /*#__PURE__*/_react.default.createElement(PromptButton, {
    promptId: _constants.PROMPT_ID.COMPACT,
    disabled: isAddingToCart,
    eidPrefix: eidPrefix,
    text: formatMessage({
      id: promptConfig?.compactText || 'searchRecommendation.prompt.compact'
    }),
    onClick: () => handlePromptSelect({
      recommendations: compactRecommendations,
      title: formatMessage({
        id: 'searchRecommendation.prompt.compact.title'
      }),
      description: formatMessage({
        id: 'searchRecommendation.prompt.compact.description'
      }),
      promptId: _constants.PROMPT_ID.COMPACT
    })
  })))))));
};
exports.PromptFlyoutContent = PromptFlyoutContent;
PromptFlyoutContent.propTypes = {
  prompts: _propTypes.default.object,
  styling: _propTypes.default.object,
  promptResult: _propTypes.default.object,
  logger: _propTypes.default.func,
  eidPrefix: _propTypes.default.string
};